import type { SxProps, Theme } from '@mui/material';

export function getSystemTableSelectionCellSx(width: number) {
  const selectionCellSx = {
    boxSizing: 'border-box',
    width,
    minWidth: width,
    maxWidth: width,
    px: 0,
    textAlign: 'center',
    // The table-level density selector has two classes, so the selection
    // column needs matching specificity to keep its content box symmetric.
    '&&': {
      px: 0,
    },
  } satisfies SxProps<Theme>;

  return selectionCellSx;
}
